export default "__VITE_ASSET__9KjwBr9k__"